import React from 'react'

let ProductSearch = (props) => {

    return (
        <div className="container">
            <nav className="navbar navbar-light bg-light">
                <form className="form-inline">
                    <input type="search" className="form-control mr-sm-2" placeholder="Search by product"
                        value={props.productSearchInput} onChange={props.productSearchOnChangeHandler}/>
                    <input type="button" value="Search" className="btn btn-outline-success my-2 my-sm-0" onClick={props.productSearchClickHandler}/>
                </form>
            </nav>            
        </div>
    )
}

export default ProductSearch;